import API from '../helpers/api';
import { getCookie, config } from '../helpers/constants';

const apiUrl = config.backendUrl + "api/";

export default class AuthService {

  static login(mail, pwd, resetCode) {
    const sid = getCookie(config.sessionCookieName);
    const cmd = 'Login';

    return API.post(`${apiUrl + cmd}`, {
      sid,
      mail,
      pwd,
      resetCode
    });
  }

  static registerUser(mail, pwd, licenseCode, regCode) {
    const sid = getCookie(config.sessionCookieName);
    const cmd = 'RegisterUser';

    return API.post(`${apiUrl + cmd}`, {
      sid,
      mail,
      pwd,
      licenseCode,
      regCode
    });
  }

  // for logout
  static logout() {
    const cmd = 'Logout';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
    });
  }

  // for get sources api
  static getSources(reportid, permaLinkId = null) {
    const cmd = 'GetSources';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      permaLinkId,
      sid,
    });
  }

  static getCollusionSources(projectId = null) {
    const cmd = 'GetCollusionSources';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      projectId,
      sid,
    });
  }

  // for get reports api
  static getReports(reportFilters) {
    const cmd = 'GetReports';
    const sid = getCookie(config.sessionCookieName);
    //alert(JSON.stringify(reportFilters));
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...reportFilters
    });
  }

  static getLicenseUsers(licenseUserFilters) {
    const cmd = 'GetLicenseUsers';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...licenseUserFilters
    });
  }

  static getLicenseUsageStatistics(licenseUserFilters, type, format) {
    const cmd = 'GetLicenseUsageStatistics';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      filters: licenseUserFilters,
      type: type,
      format: format
    });
  }

  static getLicenseUsageChartData(licenseUserFilters, type, format) {
    const cmd = 'GetLicenseUsageChartData';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...licenseUserFilters,
      type: type,
      format: format
    });
  }

  static createLicenseIntro() {
    const cmd = 'CreateLicenseIntro';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }


  static getLicenseAdmin() {
    const cmd = 'GetLicenseAdmin';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }

  static extendLicense() {
    const cmd = 'ExtendLicense';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }


  // for get reports api
  static getUploadForm(projectcode) {
    const cmd = 'GetUploadForm';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      projectcode
    });
  }

  // for get reports api
  static getLibraries(libraryFilters) {
    const cmd = 'GetLibraryTexts';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...libraryFilters
    });
  }

  // for get reports api
  static getMessages() {
    const cmd = 'GetUserMessages';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }

  static getNextMessage() {
    const cmd = 'GetNextMessage';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }

  static getSSOInfoFromMail(mail) {
    const cmd = 'GetSSOInfoFromMail';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      mail
    });
  }

  static getSSOInfo(ssoName) {
    const cmd = 'GetSSOInfo';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ssoName
    });
  }


  // for get Report Markup api
  static getReportMarkup(reportid, permaLinkId = null) {
    const cmd = 'GetReportMarkup';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      sid,
      permaLinkId
    });
  }

  // for get Report api
  static getReport(reportid, fetchfulltext = false, permaLinkId = null) {
    const cmd = 'GetReport';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      sid,
      fetchfulltext,
      permaLinkId
    });
  }

  // for get Report api
  static getLibrary(libtextid, fetchfulltext) {
    const cmd = 'GetLibraryText';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      libtextid,
      fetchfulltext,
      sid,
    });
  }

  // for get Report Status
  static getReportStatus(reportid, permaLinkId = null) {
    const cmd = 'GetReportStatus';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      permaLinkId,
      sid
    });
  }

  // for update comments api
  static UpdateReports(data, reportids, permaLinkId) {
    const cmd = 'UpdateReports';
    const title = data.title || '';
    const date = data.date || '';
    const author = data.author || '';
    const projectid = data.projectid || '';
    const comment = data.comment || '';
    const field = data.field || '';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      reportids,
      permaLinkId,
      date,
      title,
      author,
      projectid,
      comment,
      field,
      sid
    });
  }

  static UpdateProject(data, projectId) {
    const cmd = 'UpdateProject';
    const projectid = projectId;
    const name = data.name || '';
    const description = data.description || '';
    const date = data.date;
    const uploadformactive = data.uploadformactive;
    const uploadformheader = data.uploadformheader || '';
    const uploadformdescription = data.uploadformdescription || '';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      name,
      description,
      uploadformactive,
      projectid,
      uploadformheader,
      date,
      uploadformdescription,
      sid
    });
  }

  static CreateProject(data) {
    const cmd = 'CreateProject';
    const name = data.name || '';
    const description = data.description || '';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      name,
      description,
      sid
    });
  }

  static UpdateLibraries(data, textids) {
    const cmd = 'UpdateLibraryTexts';
    const title = data.title || '';
    const date = data.date || '';
    const author = data.author || '';
    const projectid = data.projectid || '';
    const comment = data.comment || '';
    const fingerprint = data.fingerprint || '';
    const field = data.field || '';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      textids,
      date,
      title,
      author,
      projectid,
      comment,
      fingerprint,
      field,
      sid
    });
  }

  // for post Update Ration api
  static updateSources(sources, reportid, permaLinkId) {
    const cmd = 'UpdateSources';
    const sid = getCookie(config.sessionCookieName);

    return API.post(`${apiUrl + cmd}`, {
      sources,
      sid,
      reportid,
      permaLinkId
    });
  }

  // for post Update Ration api
  static getSourceMarkup(sourceid, permaLinkId = null) {
    const cmd = 'GetSourceMarkup';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sourceid,
      permaLinkId,
      sid,
    });
  }

  // for get Project api
  static getProjects() {
    const cmd = 'GetProjects';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
    });
  }

  // for reset report
  static resetReport(reportid, permaLinkId) {
    const cmd = 'ResetReport';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      permaLinkId,
      sid
    });
  }

  static getTextOverlay(reportid, type, permaLinkId) {
    const cmd = 'GetTextOverlay';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      type,
      permaLinkId,
      sid
    });
  }

  static getOverlayStatistics(reportid, permaLinkId) {
    const cmd = 'GetOverlayStatistics';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      reportid,
      permaLinkId,
      sid
    });
  }


  // for get user info
  static getUserInfo() {
    const cmd = 'GetUserInfo';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }

    // setBrowserId
    static setBrowserId(browserId) {
      const cmd = 'SetBrowserId';
      const sid = getCookie(config.sessionCookieName);
      return API.post(`${apiUrl + cmd}`, {
        sid,
        browserId
      });
    }
  

  // for get user info
  static revokeMandate(mandateId) {
    const cmd = 'RevokeMandate';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      mandateId
    });
  }

  // for calculate credits
  static calculateCredits(data) {
    const cmd = 'CalculateCredits';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...data
    });
  }

  // for create check plagrsim
  static NewPlagCheck(data) {
    const cmd = 'NewPlagCheck';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...data,
    });
  }

  static AddTextsToLibrary(data) {
    const cmd = 'AddTextsToLibrary';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...data,
    });
  }

  static SyncLibraryTextsWithReports() {
    const cmd = 'SyncLibraryTextsWithReports';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
    });
  }


  // for getting text from url in provide url tab
  static getUrlContents(data) {
    const cmd = 'GetUrlContents';
    const usetags = data.usetags;
    const url = data.url
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      url,
      usetags,
      sid,
    });
  }


  static getUploadedFilesStatus(uploadids) {
    const cmd = 'GetUploadedFilesStatus';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      uploadids,
    });
  }

  static getUploadedFileInfo(uploadid, fetchFulltext = false) {
    const cmd = 'GetUploadedFileInfo';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      uploadid,
      fetchFulltext
    });
  }



  static deleteReports(reportids) {
    const cmd = 'DeleteReports';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      reportids,
    });
  }

  static activateReports(reportids) {
    const cmd = 'ActivateReports';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      reportids,
    });
  }

  // for getting text from url in provide url tab
  static deleteProject(projectid) {
    const cmd = 'DeleteProject';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      projectid,
    });
  }

  // for getting text from url in provide url tab
  static deleteLibraries(libtextids) {
    const cmd = 'DeleteLibraryTexts';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      libtextids,
    });
  }

  static createOrder(product, currency, method, taxIncluded, taxMode, vatRate, uploadId) {
    const cmd = 'CreateOrder';
    const productid = product.id;
    const amount = product.cost[currency];
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      productid,
      currency,
      taxIncluded,
      taxMode,
      vatRate,
      method,
      uploadId
    });
  }

  static createPayment(invoiceId, method) {
    const cmd = 'CreatePayment';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      invoiceId,
      method
    });
  }

  static updateLicense(license, attribs) {
    const cmd = 'UpdateLicense';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      license,
      ...attribs
    });
  }

  static verifyReCaptcha(token) {
    const cmd = 'VerifyReCaptcha';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      token
    });
  }

  static getProducts() {
    const cmd = 'GetProducts';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }

  static getCountries() {
    const cmd = 'GetCountries';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }

  // update user
  static updateInvoiceAddress(invoiceAddress) {
    const cmd = 'UpdateUser';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...invoiceAddress
    });
  }

  static updateUser(userData) {
    const cmd = 'UpdateUser';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...userData
    });
  }

  static updateUserAttrib(name, value) {
    const cmd = 'UpdateUserAttrib';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      attrib: name,
      value: value
    });
  }


  static removeUserLicense(userId) {
    const cmd = 'RemoveUserLicense';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      userId
    });
  }


  // update user settings
  static updateUserSettings(settings) {
    const cmd = 'UpdateUserSettings';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...settings
    });
  }

  // update user password
  static updateUserPassword(password) {
    const cmd = 'UpdateUserPassword';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      password
    });
  }

  // create user code 
  static createUserCode() {
    const cmd = 'CreateUserCode';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }

  // Delete User Account
  static deleteUser() {
    const cmd = 'DeleteUser';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }

  static getOrders() {
    const cmd = 'GetOrders';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
    });
  }

  static getPaymentStatus(invoiceId) {
    const cmd = 'GetPaymentStatus';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      invoiceId
    });
  }

  static getInvoiceData(invoiceId) {
    const cmd = 'GetInvoiceData';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      invoiceId
    });
  }

  // for get news data api
  static loadNews(reportFilters) {
    const cmd = 'GetNews';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
    });
  }

  // for get report chart data api
  static getChartData(mode) {
    const cmd = 'GetReportsStatistics';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      mode
    });
  }

  // Create guest user
  static createGuestUser() {
    const cmd = 'CreateGuestUser';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }

  // Send quote mail
  static sendQuoteMail(quote) {
    const cmd = 'SendQuoteMail';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...quote
    });
  }

  static sendContactMail(contactData) {
    const cmd = 'SendContactMail';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...contactData
    });
  }


  static sendPasswordResetMail(mail) {
    const cmd = 'SendPasswordResetMail';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      mail
    });
  }

  static setLanguage(lang) {
    const cmd = 'SetLanguage';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      lang,
      sid
    });
  }

  static createPdfReport(settings) {
    const cmd = 'CreatePdfReport';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      ...settings
    });
  }

  static resolvePermaLink(permaLinkId, action) {
    const cmd = 'ResolvePermaLink';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      permaLinkId,
      action
    });
  }

  static createCollusionReport(projectId) {
    const cmd = 'GenerateCollusionReport';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      projectId
    });
  }

  static deleteCollusionReport(projectId) {
    const cmd = 'DeleteCollusionReport';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      projectId
    });
  }

  static returnToSession() {
    const cmd = 'ReturnToSession';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }

  static addUsers(userText, syncUsers, previewOnly) {
    const cmd = 'AddUsers';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid,
      userText,
      syncUsers,
      previewOnly
    });
  }

  static uploadUserList(file) {
    const cmd = 'UploadUserList';
    const sid = getCookie(config.sessionCookieName);
    const formData = new FormData();
    formData.append("file", file, file.name ); 
    formData.append("sid", sid ); 

    return API.formPost(`${apiUrl + cmd}`, formData );
  }

  static loadFAQs() {
    const cmd = 'GetFAQs';
    const sid = getCookie(config.sessionCookieName);
    return API.post(`${apiUrl + cmd}`, {
      sid
    });
  }


}
